import $ from 'jquery';
import 'jquery-bridget';
import 'infinite-scroll';

function blog() {
	var $postContainer = $('.c-infinite-scroll');

	if( !$postContainer ) return;

	$postContainer.infiniteScroll({
		append: '.c-blog_row',
		history: false,
		path: '.pagination .next',
		hideNav: '.page-navigation'
	});
}

export { blog };